 
(function () {
  'use strict';

  var SEND_ON_MAX_DAYS = 90;
  var DAY_MS = 86400000;

  class GiftRecipient extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('[data-recipient-checkbox]');
      this.panel = this.querySelector('[data-recipient-fields]');
      if (!this.checkbox || !this.panel) return;

      this.fields = Array.prototype.slice.call(
        this.querySelectorAll('[data-recipient-field]')
      );
      this.emailInput = this.querySelector('[data-recipient-field="email"]');
      this.sendOnInput = this.querySelector('[data-recipient-field="send_on"]');
      this.form =
        (this.checkbox.form) ||
        this.closest('form') ||
        document.querySelector('form[action*="/cart/add"]');
 
      var emailLabel = this.querySelector('[data-recipient-email-label]');
      if (emailLabel && this.dataset.textEmailLabel) {
        emailLabel.textContent = this.dataset.textEmailLabel;
      }

      this.onToggle = this.onToggle.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.onInput = this.onInput.bind(this);

      this.checkbox.addEventListener('change', this.onToggle);
      this.addEventListener('input', this.onInput); 
      if (this.form) this.form.addEventListener('submit', this.onSubmit, true);

      this.syncState();
    }

    disconnectedCallback() {
      if (this.checkbox) this.checkbox.removeEventListener('change', this.onToggle);
      this.removeEventListener('input', this.onInput);
      if (this.form) this.form.removeEventListener('submit', this.onSubmit, true);
    }

    get isActive() {
      return !!(this.checkbox && this.checkbox.checked);
    }

    onToggle() {
      this.syncState();
      if (this.isActive) {
        var first = this.querySelector('[data-recipient-field="name"]') || this.emailInput;
        if (first) first.focus();
      }
    }

    /** Mirror the checkbox into panel visibility, input disabled state and a11y. */
    syncState() {
      var active = this.isActive;

      this.panel.hidden = !active;
      this.checkbox.setAttribute('aria-expanded', active ? 'true' : 'false');

      this.fields.forEach(function (field) {
        field.disabled = !active;
      });

      if (this.emailInput) {
        if (active) {
          this.emailInput.setAttribute('required', '');
          this.emailInput.setAttribute('aria-required', 'true');
        } else {
          this.emailInput.removeAttribute('required');
          this.emailInput.removeAttribute('aria-required');
        }
      }

      if (!active) this.clearErrors();
    }

    onInput(event) {
      var field = event.target.closest && event.target.closest('[data-recipient-field]');
      if (field) this.clearError(field.dataset.recipientField);
    }

    onSubmit(event) {
      if (this.validate()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    /**
     * Validate the recipient fields. Returns true when the form may proceed. 
     */
    validate() {
      if (!this.checkbox || !this.isActive) return true;

      this.clearErrors();

      if (this.emailInput) {
        var email = (this.emailInput.value || '').trim();
        if (!email) {
          return this.fail('email', this.dataset.textEmailBlank);
        }
        if (!this.emailInput.checkValidity()) {
          return this.fail('email', this.dataset.textEmailAlert);
        }
      }

      if (this.sendOnInput && this.sendOnInput.value) {
        if (!this.isSendOnWithinLimit(this.sendOnInput.value)) {
          return this.fail('send_on', this.dataset.textSendOnLimit);
        }
      }

      return true;
    }

    /**
     * Shopify rejects a Send on date more than 90 days out. 
     */
    isSendOnWithinLimit(value) {
      var parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
      if (!parts) return false;

      var picked = Date.UTC(+parts[1], +parts[2] - 1, +parts[3]);
      if (isNaN(picked)) return false;

      var now = new Date();
      var today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());

      return picked >= today && picked <= today + SEND_ON_MAX_DAYS * DAY_MS;
    }

    fail(name, message) {
      var input = this.querySelector('[data-recipient-field="' + name + '"]');
      var errorEl = this.querySelector('[data-recipient-error-for="' + name + '"]');

      if (errorEl && message) {
        errorEl.textContent = message;
        errorEl.hidden = false;
      }
      if (input) {
        input.setAttribute('aria-invalid', 'true');
        input.focus();
      }
      return false;
    }

    clearError(name) {
      if (!name) return;
      var input = this.querySelector('[data-recipient-field="' + name + '"]');
      var errorEl = this.querySelector('[data-recipient-error-for="' + name + '"]');
      if (errorEl) {
        errorEl.hidden = true;
        errorEl.textContent = '';
      }
      if (input) input.removeAttribute('aria-invalid');
    }

    clearErrors() {
      Array.prototype.forEach.call(
        this.querySelectorAll('[data-recipient-error-for]'),
        function (el) {
          el.hidden = true;
          el.textContent = '';
        }
      );
      this.fields.forEach(function (field) {
        field.removeAttribute('aria-invalid');
      });
    }

    /** Snapshot for restoring across a variant-driven section swap. */
    serialize() {
      var state = { checked: this.isActive, values: {} };
      this.fields.forEach(function (field) {
        state.values[field.dataset.recipientField] = field.value;
      });
      return state;
    }

    restore(state) {
      if (!state || !this.checkbox) return;
      this.checkbox.checked = !!state.checked;
      this.fields.forEach(function (field) {
        var value = state.values && state.values[field.dataset.recipientField];
        if (value) field.value = value;
      });
      this.syncState();
    }
  }

  if (!customElements.get('gift-recipient')) {
    customElements.define('gift-recipient', GiftRecipient);
  }
})();
